import render from 'preact-render-to-string';
import { Link, route } from 'preact-router';
import { useState, useEffect } from 'preact/hooks';
import Table from './Table';
import SubmitButton from './SubmitButton';
import sexItems from '../../consts';

function FormEvent({ children, title, onSubmit, eventInfo, setEventInfo, message, submitButtonDisabled }) {
    const [saveForm, setSaveForm] = useState(false);

    const columns = [
        { label: "Nom", accessor: "name", sortable: false },
        { label: "Sexe", accessor: "sex", sortable: false },
        { label: "Terrain", accessor: "location", sortable: false },
        { label: "Suitee", accessor: "followed", sortable: false },
    ];

    const cellFormat = function (value, accessor, data) {
        let str = value;
        if (accessor == 'sex') {
            str = sexItems[value];
        } else if (accessor == 'location') {
            str = <Link className="nav-animal" href={'/location/' + value.id}><div dangerouslySetInnerHTML={{ __html: value.fullName }} /></Link>
            str = render(str);

        } else if (accessor == 'name') {
            str = render(<Link href={'/animal/' + data.id}>{value}</Link>);
            data.markers.forEach(marker => {
                str += '<div class="marker-shape" style="background-color:' + marker.color + '"></div>';
            })
            if (data.exited) {
                str = '<div class="exited">' + data.name + '</div>';
            }
        }
        return str;
    }

    useEffect(() => {
        if (localStorage.getItem('saveEvent') && eventInfo.isCreateEvent) {
            let fields = JSON.parse(localStorage.getItem('saveEvent'));
            eventInfo.date = fields.date;
            eventInfo.notes = fields.notes;
            for (const p in fields) {
                if (p != 'date' && p != 'notes') {
                    eventInfo[p] = fields[p];
                }
            }
            setEventInfo(JSON.parse(JSON.stringify(eventInfo)));
            localStorage.removeItem('saveEvent');
        }
    }, []);

    const handleAddAnimal = function (e) {
        setSaveForm(true);
    }

    const onPreSubmit = function (e) {
        e.preventDefault();
        e.returnValue = '';
        if (saveForm) {
            const fields = Array.from(e.target);
            const o = {};
            fields.map(field => {
                if (field.type == "checkbox") {
                    if (!!field.checked) {
                        if (typeof o[field.name] == "undefined") o[field.name] = [];
                        o[field.name].push(field.value);
                    }
                }
                else if (field.value && field.name != "") {
                    o[field.name] = field.value;
                }
            });
            localStorage.setItem('saveEvent', JSON.stringify(o));
            route('/animals');
        }
        else {
            onSubmit(e);
        }
    }

    return (
        <div class="container-md mt-2">
            <h1 class="text-center">{title}</h1>
            {message && <div class="alert alert-warning">{message}</div>}
            <form class="mt-4" onSubmit={onPreSubmit}>
                <div class="form-floating  mb-3">
                    <input class="form-control" id="date" type="date" name="date" defaultValue={eventInfo.date} />
                    <label class="form-label" for="date">Date</label>
                </div>
                {children}
                <div class="form-floating mb-3">
                    <textarea class="form-control" id="notes" name="notes" style="height:100px">{eventInfo.notes}</textarea>
                    <label class="form-label" for="notes">Notes</label>
                </div>
                <SubmitButton disabled={submitButtonDisabled} />
                <div class="mt-4 table-responsive">
                    {eventInfo.selectedAnimals.length == 0
                        && <span>Aucun animal sélectionné</span>
                        || <Table id="animals" caption="Animaux concernés" columns={columns} selectable={false} data={eventInfo.selectedAnimals} cellFormat={cellFormat} />
                    }
                    {eventInfo.isCreateEvent && !eventInfo.isUnique && <button class="action-button btn btn-secondary ms-2 mb-5" type="submit" value="submit" onClick={handleAddAnimal}>+</button>}
                </div>
                
            </form>

        </div>
    )
}

export default FormEvent;